import { Row, Col, Card, Typography, Tag, Progress } from 'antd';
import { backgroundTokens, greyScaleTokens, variantTokens, primaryShades, statusTokens } from '../../theme/theme';
import dayjs from 'dayjs';

const CardInformativeSection = ({ subscription, percentage, daysLeft, mainDomain, color }) => {
    const { Text } = Typography;

    // Determina se la sottoscrizione è scaduta
    const isExpired = () => {
        // Verifica se daysLeft è 0 o se la endDate è nel passato
        if (daysLeft === 0) return true;

        if (!subscription?.endDate) return false;

        let endDate;
        if (typeof subscription.endDate === 'string') {
            endDate = dayjs(subscription.endDate);
        } else if (subscription.endDate.seconds) {
            endDate = dayjs.unix(subscription.endDate.seconds);
        } else {
            endDate = dayjs(subscription.endDate);
        }

        return endDate.isBefore(dayjs(), 'day');
    };

    const subscriptionExpired = isExpired();

    return (
        <Row gutter={[16, 16]} style={{ marginBottom: '1rem' }}>
            {/* Prima Card Informativa */}
            <Col xs={24} md={12}>
                <Card
                    style={{
                        borderRadius: '0.5rem',
                        height: '100%',
                        backgroundColor: backgroundTokens.whiteBg,
                        borderColor: greyScaleTokens.grey300
                    }}
                    styles={{
                        body: {
                            display: 'flex',
                            flexDirection: 'column',
                            padding: '1.5rem',
                            height: '100%'
                        }
                    }}
                >
                    {/* Subscription Type */}
                    <div style={{ marginBottom: '1.5rem' }}>
                        <span style={{
                            fontSize: '1.25rem',
                            fontWeight: 'bold',
                            color: variantTokens.black
                        }}>
                            {subscription.subscriptionType || 'N/A'}
                        </span>
                    </div>

                    {/* Start Date e End Date */}
                    <div style={{ marginBottom: '1.5rem' }}>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem', fontSize: '0.875rem' }}>
                            <div>
                                <Text
                                    type="secondary"
                                    strong
                                    style={{
                                        fontSize: '0.75rem',
                                        color: greyScaleTokens.grey600
                                    }}
                                >
                                    Start Date:
                                </Text>
                                <br />
                                <Text style={{
                                    fontSize: '0.875rem',
                                    color: variantTokens.black
                                }}>
                                    {subscription.startDate ? (
                                        subscription.startDate.seconds
                                            ? dayjs.unix(subscription.startDate.seconds).format('DD/MM/YYYY')
                                            : dayjs(subscription.startDate).format('DD/MM/YYYY')
                                    ) : 'N/A'}
                                </Text>
                            </div>
                            <div>
                                <Text
                                    type="secondary"
                                    strong
                                    style={{
                                        fontSize: '0.75rem',
                                        color: greyScaleTokens.grey600
                                    }}
                                >
                                    End Date:
                                </Text>
                                <br />
                                <Text style={{
                                    fontSize: '0.875rem',
                                    color: variantTokens.black
                                }}>
                                    {subscription.endDate ? (
                                        subscription.endDate.seconds
                                            ? dayjs.unix(subscription.endDate.seconds).format('DD/MM/YYYY')
                                            : dayjs(subscription.endDate).format('DD/MM/YYYY')
                                    ) : 'N/A'}
                                </Text>
                            </div>
                        </div>
                    </div>



                    {/* Active Services */}
                    <div style={{ marginBottom: '1.5rem' }}>
                        <div style={{
                            fontSize: '0.875rem',
                            color: greyScaleTokens.grey600,
                            marginBottom: '0.75rem',
                            fontWeight: '500'
                        }}>
                            ACTIVE SERVICES
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                            <Tag
                                style={{
                                    fontSize: '0.75rem',
                                    padding: '0.25rem 0.5rem',
                                    margin: 0,
                                    backgroundColor: primaryShades.primary200,
                                    border: 'none',
                                    color: '#FFFFFF'
                                }}
                            >
                                WEB VTO
                            </Tag>
                            <Tag
                                style={{
                                    fontSize: '0.75rem',
                                    padding: '0.25rem 0.5rem',
                                    margin: 0,
                                    backgroundColor: primaryShades.primary200,
                                    border: 'none',
                                    color: '#FFFFFF'
                                }}
                            >
                                3D AR VIEWER
                            </Tag>
                            <Tag
                                style={{
                                    fontSize: '0.75rem',
                                    padding: '0.25rem 0.5rem',
                                    margin: 0,
                                    backgroundColor: primaryShades.primary200,
                                    border: 'none',
                                    color: '#FFFFFF'
                                }}
                            >
                                VTO APPS
                            </Tag>
                        </div>
                    </div>

                    {/* Domains */}
                    <div style={{ flex: 1 }}>
                        {/* Target Domains */}
                        <div style={{ marginBottom: '1rem' }}>
                            <div style={{
                                fontSize: '0.875rem',
                                color: greyScaleTokens.grey600,
                                marginBottom: '0.5rem',
                                fontWeight: '500'
                            }}>
                                TARGET DOMAINS
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.25rem' }}>
                                    {Array.isArray(subscription.list_allowed_domains) && subscription.list_allowed_domains.length > 0 ? (
                                        subscription.list_allowed_domains.map((domain, index) => (
                                            <span
                                                key={index}
                                                style={{
                                                    color: variantTokens.accent,
                                                    fontSize: '0.875rem',
                                                    fontWeight: '500',
                                                    cursor: 'pointer',
                                                    textDecoration: 'underline',
                                                    transition: 'opacity 0.2s ease'
                                                }}
                                                onClick={() => {
                                                    const url = domain.startsWith('http') ? domain : `https://${domain}`;
                                                    window.open(url, '_blank', 'noopener,noreferrer');
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.opacity = '0.8';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.opacity = '1';
                                                }}
                                            >
                                                {domain}{index < subscription.list_allowed_domains.length - 1 ? ', ' : ''}
                                            </span>
                                        ))
                                    ) : (
                                        <span style={{
                                            color: variantTokens.accent,
                                            fontSize: '0.875rem',
                                            fontWeight: '500'
                                        }}>
                                            N/A
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Main Domain */}
                        <div>
                            <div style={{
                                fontSize: '0.875rem',
                                color: greyScaleTokens.grey600,
                                marginBottom: '0.5rem',
                                fontWeight: '500'
                            }}>
                                SERVICE SUBDOMAIN
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                {mainDomain ? (
                                    <span
                                        style={{
                                            color: variantTokens.accent,
                                            fontSize: '0.875rem',
                                            fontWeight: '500',
                                            cursor: 'pointer',
                                            textDecoration: 'underline',
                                            transition: 'opacity 0.2s ease'
                                        }}
                                        onClick={() => {
                                            const url = mainDomain.startsWith('http') ? mainDomain : `https://${mainDomain}?c=${subscription.mainCatalogRef}`;
                                            window.open(url, '_blank', 'noopener,noreferrer');
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.opacity = '0.8';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.opacity = '1';
                                        }}
                                    >
                                        {mainDomain}
                                    </span>
                                ) : (
                                    <span style={{
                                        color: variantTokens.accent,
                                        fontSize: '0.875rem',
                                        fontWeight: '500'
                                    }}>
                                        N/A
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>


                </Card>
            </Col>

            {/* Seconda Card Informativa - Usage Statistics */}
            <Col xs={24} md={12}>
                <Card
                    style={{
                        borderRadius: '0.5rem',
                        height: '100%',
                        backgroundColor: backgroundTokens.whiteBg,
                        borderColor: greyScaleTokens.grey300
                    }}
                    styles={{
                        body: {
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            padding: '1.5rem',
                            height: '100%'
                        }
                    }}
                >
                    {/* Days Left Progress con Badge - Solo se non è scaduta */}
                    {!subscriptionExpired && (
                        <div style={{ marginBottom: '1.5rem' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                                <span style={{
                                    fontSize: '0.875rem',
                                    color: greyScaleTokens.grey600,
                                    fontWeight: '500'
                                }}>
                                    DAYS LEFT
                                </span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                                <div style={{ flex: 1 }}>
                                    <Progress
                                        percent={percentage}
                                        showInfo={false}
                                        strokeColor={color}
                                        trailColor={greyScaleTokens.grey200}
                                        size="default"
                                    />
                                </div>
                                <div style={{
                                    backgroundColor: backgroundTokens.greyBg,
                                    padding: '0.25rem 0.75rem',
                                    borderRadius: '1rem',
                                    minWidth: '3.125rem',
                                    textAlign: 'center'
                                }}>
                                    <span style={{
                                        fontSize: '0.875rem',
                                        fontWeight: 'bold',
                                        color: variantTokens.black
                                    }}>
                                        {daysLeft}
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Usage Statistics */}
                    <div style={{ flex: 1 }}>
                        <div style={{ marginBottom: '1rem' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span style={{
                                    fontSize: '1.125rem',
                                    fontWeight: 'bold',
                                    color: variantTokens.black
                                }}>
                                    SKU USED
                                </span>
                                <span style={{
                                    fontSize: '1.5rem',
                                    fontWeight: 'bold',
                                    color: variantTokens.black
                                }}>
                                    {subscription.skuUsed || 0}<span style={{
                                        fontSize: '1.125rem',
                                        fontWeight: 'normal',
                                        color: greyScaleTokens.grey500
                                    }}>
                                        /{(subscription.list_catalogues?.skuLimit === 0 || !subscription.list_catalogues?.skuLimit) ? '∞' : subscription.list_catalogues?.skuLimit}
                                    </span>
                                </span>
                            </div>
                        </div>

                        <div style={{ marginBottom: '1rem' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span style={{
                                    fontSize: '1.125rem',
                                    fontWeight: 'bold',
                                    color: variantTokens.black
                                }}>
                                    CATALOGUES
                                </span>
                                <span style={{
                                    fontSize: '1.5rem',
                                    fontWeight: 'bold',
                                    color: variantTokens.black
                                }}>
                                    {(subscription.list_catalogues.list_catalogues_refs?.length || 0)}<span style={{
                                        fontSize: '1.125rem',
                                        fontWeight: 'normal',
                                        color: greyScaleTokens.grey500
                                    }}></span>
                                </span>
                            </div>
                        </div>

                        <div style={{ marginBottom: '1rem' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span style={{
                                    fontSize: '1.125rem',
                                    fontWeight: 'bold',
                                    color: variantTokens.black
                                }}>
                                    GB ALLOWED
                                </span>
                                <span style={{
                                    fontSize: '1.5rem',
                                    fontWeight: 'bold',
                                    color: variantTokens.black
                                }}>
                                    {subscription.gbUsed || 0}<span style={{
                                        fontSize: '1.125rem',
                                        fontWeight: 'normal',
                                        color: greyScaleTokens.grey500
                                    }}>
                                        /{subscription.list_catalogues?.consumptionLimit === 0 ? '∞' : (subscription.list_catalogues?.consumptionLimit || 'ND')}
                                    </span>
                                </span>
                            </div>
                            {/* Limit exceeded warning */}
                            {subscription.list_catalogues?.consumptionLimit > 0 && (subscription.gbUsed || 0) > subscription.list_catalogues?.consumptionLimit && (
                                <div style={{
                                    marginTop: '0.5rem',
                                    padding: '0.5rem 0.75rem',
                                    backgroundColor: `${statusTokens.error}15`,
                                    border: `1px solid ${statusTokens.error}40`,
                                    borderRadius: '0.375rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem'
                                }}>
                                    <span style={{ fontSize: '1rem' }}>⚠️</span>
                                    <div>
                                        <div style={{
                                            fontSize: '0.75rem',
                                            fontWeight: 'bold',
                                            color: statusTokens.error
                                        }}>
                                            LIMIT EXCEEDED
                                        </div>
                                        <div style={{
                                            fontSize: '0.6875rem',
                                            color: `${statusTokens.error}CC`
                                        }}>
                                            Over by {((subscription.gbUsed || 0) - subscription.list_catalogues?.consumptionLimit).toFixed(2)} GB
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </Card>
            </Col>
        </Row>
    );
};

export default CardInformativeSection;